import { Injectable } from '@angular/core';
declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GAnalyticsService {

  constructor() { 
  }
  public sendEvent( 
    eventName: string, 
    eventCategory: string, 
    eventAction: string, 
    eventLabel: string = "",  
    eventValue?: any ){ 
      //@ts-ignore
      window?.sendGAEvent?.call && window?.sendGAEvent(eventName, eventCategory, eventAction, eventLabel, eventValue); 
    }

    public webEngageEvent(eventValue){
      //@ts-ignore
      window?.sendGAEvent?.call && window?.sendGAEvent(eventValue)
    }
}
